module.exports = __webpack_public_path__ + "static/media/vk.13b8fd46.svg";